import $ from 'jquery';

const SELECTOR = {
    SEARCH_CONTAINER: '.js-search-wrapper',
    SEARCH_BTN: '.js-search-menu',
    SEARCH_FIELD: '.js-main-search_field',
    SEARCH_FIELD_MOBILE: '.js-main-search_field-mobile',
    SEARCH_RESULT_LIST: '.js-main-search_list',
    SEARCH_BTN_FORM: '.js-search-form-btn'
}

const KEY = {
    UP: 38,
    DOWN: 40,
    ESC: 27,
    ENTER: 13,
    SPACE: 27,
	TAB: 9
};

const MIN_SEARCH_CHARS = 3;

// mock ajax call getting json list
var searchList ;

const CLASS = {
    IS_OPEN: 'is-open',
    IS_ACTIVE: 'is-active'
}

export default class SearchPanel {
	
    constructor(selectorPanel, itemIdPrefix, isMobile) {
        var _self = this;
        _self.itemIdPrefix = itemIdPrefix;
		_self.isMobile = isMobile;

        _self.$el = $(selectorPanel);
        _self.$btn = _self.$el.find(SELECTOR.SEARCH_BTN);
        _self.$container = $(SELECTOR.SEARCH_CONTAINER);
		// _self.$el / selectorPanel (conteneur) est valable seulement pour mobile,
		// pour desktop le conteneur correspond au '.js-search-wrapper'
        _self.$searchField = isMobile ? _self.$el.find(SELECTOR.SEARCH_FIELD_MOBILE) : _self.$container.find(SELECTOR.SEARCH_FIELD);
        _self.$searchResultList = _self.$container.find(SELECTOR.SEARCH_RESULT_LIST);
        _self.$searchForm = _self.$container.find('form');
        _self.$searchBtnForm = _self.$container.find(SELECTOR.SEARCH_BTN_FORM);
        _self.$document = $(document);
		_self.$searchEraseBtn = _self.$container.find('.js-main-search_erase2');

        _self.isOpen = false;
        _self.focusIndex = -1;

        _self.loadList();
        _self.handleEventsGlobal();
        _self.handleEventsInSearchField();
		
		_self.$btn.attr("aria-expanded","false");
		_self.$searchResultList.css('display', 'none');
    }

    /**
     * Ajax call to initialize context
     */
    loadList() {
        var url = $("#hidden-autocompletion-file").html();
        if (url) {
            $.ajax({
                url: url.trim(),
                method: "GET",
                dataType: "json",
                success: function (response) {
                    searchList = response.filterList;
                },
                error: function () {
                    console.log('Erreur du chargement de la liste');
                }
            });
        }
    };

    escapeRegexpChars(chars) {
        return chars.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

	searchFldFocus() {
		//_self.$container = $('.js-search-wrapper'); _self.$container.find('.js-main-search_field');		
		$('.js-search-wrapper').find('.js-main-search_field').focus();
	}


    /**
     * buildResultList
     */
    buildResultList(e) {
        var _self = this;
        let searchEntry = _self.escapeRegexpChars(_self.$searchField.val());
        var resultList = "";

        _self.resultListLen = 0;
        _self.$searchField.html('');

        if (_self.isSearchListDefined()) {
            searchList.filter( (listEntry) => _self.hasItem(listEntry, searchEntry)
            ).forEach( (item, index) => {
				let itemWithHighlight = _self.highlight(item, searchEntry);

				resultList += `<li
								id='${this.itemIdPrefix}-${index}'
								class='rsp_search-box__item' role='option' tabindex='-1' >${itemWithHighlight}</li>`;
				_self.resultListLen++;
			});
        }

        _self.$searchResultList.html(resultList);
    }

    /**
     * Handle all needed events
     */
    handleEventsGlobal() {
        var _self = this;

        // Event use to open / close the search field
        _self.$btn.bind("click", function (e) {
			
            if (_self.isOpen) {
                _self.closeSearch(false);
            } else {
                _self.openSearch();
                document.querySelector("#searchBox").addEventListener("transitionend", _self.searchFldFocus );
				// Close search clicking outside of the research bar
				_self.$document.on('click', function (e) {
					if (_self.isOpen) {
						e.stopPropagation();
						_self.closeSearch(false);
					}
				});				
            }
            e.stopPropagation();
        });
		
        // Event that prevent submit of form if searchField is empty
        // TODO : why focusIndex here ?
		// $el is not a form but the container <li ?!
        _self.$el.submit(e => {
            //if (this.isEmpty(this.$searchField.val()) || this.focusIndex !== -1) 
            e.preventDefault();
        });

        // bind on click on autocomplete element
        _self.$searchResultList.mousedown(e => {
            if (e.target.tagName === 'LI') {
                _self.$searchField.val(_self.trimSpaces(e.target.textContent));

                // Perform the search
                _self.submitMainSearchField(_self.$searchField);
            }
        });

        // bind click btn form
        _self.$searchBtnForm.bind('click', function (e) {
			e.preventDefault();
            e.stopPropagation();			
            _self.submitMainSearchField(_self.$searchField);
        });

		// Close form when user leaves form with tab
		// Tab sur dernière bouton, on quitte le formulaire : fermer
        _self.$searchBtnForm.keydown(e => {
			if (!e.shiftKey && e.keyCode === KEY.TAB)
				e.stopPropagation();
                e.preventDefault();
				_self.closeSearch(true);
        });
		
		// Erase button (on click or enter : clear search field
		if (_self.$searchEraseBtn !== undefined) {
			
			_self.$searchEraseBtn.mousedown(e => {
				e.preventDefault();
				e.stopPropagation();

				_self.clearSearchField();
			});
			
			_self.$searchEraseBtn.keyup(e => {
                if (e.keyCode === KEY.ENTER) {
					e.preventDefault();
					e.stopPropagation();
					_self.clearSearchField();
				}
			});	
		}

		if (!_self.isMobile && _self.$container !== undefined) {

			_self.$container.keyup(e => {
				switch (e.keyCode) {
					case KEY.ESC :
						_self.closeSearch(true);
					break;
				}
			});
			
			// Ca ne fonctionne pas (ni pour container) ?
	        _self.$searchForm.blur(e => { _self.closeSearch(true);});			
		}
		
        // Do not close search bar clicking on it
        _self.$container.bind('click', function (e) {
            e.stopPropagation();
        });
		
    }
	
    /** Open Search */
    openSearch() {
        this.$container.addClass(CLASS.IS_OPEN);
		this.$btn.attr("aria-expanded","true");
        this.isOpen = true;
    }

    /** Close Search */
    closeSearch(searchbtnfocus) {
        var _self = this;
		
        this.$container.removeClass(CLASS.IS_OPEN);
		this.$btn.attr("aria-expanded","false");
        this.isOpen = false;
		
        _self.emptyList();

		if (searchbtnfocus)
			this.$btn.focus();
		
		_self.$document.off('click');
    }

	/** Clear search field */
	clearSearchField() {
        var _self = this;
		
		_self.$searchField.val('');
		_self.$searchField.focus();
		
		if (!_self.isMobile) {
			_self.emptyList();
			if (_self.$searchEraseBtn !== undefined) 
				_self.$searchEraseBtn.addClass('dcw_hidden');
		}
	}
	
	/** Clear search list */
    emptyList() {
        var _self = this;	
        _self.$searchResultList.html(''); // Comment this line out to keep list for tests
		_self.$searchResultList.css('display', 'none');
        _self.focusIndex = -1;
		_self.$searchField.attr("aria-expanded","false");
    }

	
    /**
     * Handle event linked to Search Field
     */
    handleEventsInSearchField(e) {
        var _self = this;

        let index;

        // On focus on search field, put active class on parent
        _self.$searchField.focus( e => {
			// 1x focus annuler le setfocus à la fin de transitioned
			// comme activé par le clic sur bouton recherche :
            // document.querySelector("#searchBox").addEventListener("transitionend", _self.searchFldFocus);
            document.querySelector("#searchBox").removeEventListener("transitionend", _self.searchFldFocus);

            _self.$el.addClass(CLASS.IS_ACTIVE);
        });

        // Blur : Css animation of text research when user leave search box
        _self.$searchField.blur(e => {
            if (_self.isEmpty(e.target.value))
                _self.$el.removeClass('is-active');
			
			if (!_self.isMobile)
				_self.emptyList();
        });

        // On click on search field block propagation
        _self.$searchField.click( e => {
            e.stopPropagation();
        });

		/**
		 * On press key down, stop propagation
		 * Navigate in list, perform search if key is "enter"
		 */		
        _self.$searchField.keydown(e => {
			
			// Close form when user leaves form with tab
			if (e.shiftKey && e.keyCode === KEY.TAB) {
				e.stopPropagation();
				e.preventDefault();
				_self.closeSearch(true);
			}	
			else {
			  switch (e.keyCode) {
				
				case KEY.ENTER:
				
					e.stopPropagation();
					e.preventDefault();
					
					// Recherche sur la ligne sélectionnée indexée avec focusIndex
					// A noter que focusIndex est seulement > -1 après sélection avec les flèches
					// Comme devient -1 au blur (donc focus) du champ de saisie est à chaque changement du champ
					if (_self.focusIndex > -1) {
						_self.$searchField.val(_self.getItemValueByIndex(_self.focusIndex));
						_self.emptyList();
						_self.updateActiveDescendantByIndex(_self.focusIndex);
					}
					
					if (_self.$searchField.val() !== "" && _self.$searchField.val() !== null)
						_self.submitMainSearchField(_self.$searchField);
					
					break;
					
				case KEY.ESC:
				
					e.stopPropagation();
					_self.clearSearchField();
					break;
					
				case KEY.DOWN:
				
					if (!_self.isMobile) {
					
						e.stopPropagation();
						e.preventDefault();
						index = _self.getNextIndex(_self.focusIndex);
						if (index === _self.focusIndex)
							return;
						_self.removePseudoFocus(_self.focusIndex);
						_self.addPseudoFocus(index);
						_self.updateActiveDescendantByIndex(index);
						_self.focusIndex = index;
					}	
					break;
					
				case KEY.UP:
				
					if (!_self.isMobile) {
						e.stopPropagation();
						e.preventDefault();
											
						index = _self.getPrevIndex(_self.focusIndex);
						if (index === _self.focusIndex)
							return;
						_self.removePseudoFocus(_self.focusIndex);
						_self.addPseudoFocus(index);
						_self.focusIndex = index;
					}	
					break;
			  }
			}
        });

		// keyup
        _self.$searchField.keyup(e => {
			
			if (!_self.isMobile) {
			
				// start list from 3 characters entered
				switch (_self.shouldStartAutoCompletion()) {
				case true:
					_self.emptyList();
					break;

				case false:
					if (e.keyCode === KEY.DOWN ||
						e.keyCode === KEY.UP ||
						e.keyCode === KEY.ENTER ||
						e.keyCode === KEY.SPACE) return;

					// Reset index liste
					_self.focusIndex = -1;
					
					// Create liste
					_self.$searchResultList.css('display', 'block');
   					_self.buildResultList(e);
					
					if (_self.resultListLen>0) {
						_self.$searchField.attr("aria-expanded","true");
					}
					else 
						_self.emptyList();
					
					break;
				}
				
				// Show erasebutton as soon as user types something
				if (_self.$searchEraseBtn !== undefined) {
					if (_self.$searchField.val() !== "") 
						_self.$searchEraseBtn.removeClass('dcw_hidden');
					else
						_self.$searchEraseBtn.addClass('dcw_hidden');
				}	
			}
        });
    }


    addPseudoFocus(index) {
        this.$searchResultList.find('li').eq(index).addClass('is-focus');
		this.$searchResultList.find('li').eq(index).attr("aria-selected","true");
    }

    removePseudoFocus(index) {
        this.$searchResultList.find('li').eq(index).removeClass('is-focus');
		this.$searchResultList.find('li').eq(index).attr("aria-selected","false");
    }

    getNextIndex(index) {
        return Math.min(index + 1, this.resultListLen - 1);
    }

    getPrevIndex(index) {
        return Math.max(index - 1, 0);
    }

    isEmpty(value) {
        return value === "";
    }

    updateActiveDescendantByIndex(index) {
        this.$searchField.attr(
            'aria-activedescendant',
            this.getItemIdByIndex(index)
        );
    }

    getItemIdByIndex(index) {
        if (index === -1) return null;
        return this.itemIdPrefix + '-' + index;
    }

    getItemValueByIndex(index) {
        return this.trimSpaces(
            this.$searchResultList
                .find('li')
                .eq(index)
                .text()
        );
    }

    shouldStartAutoCompletion() {
        return this.$searchField.val().length < MIN_SEARCH_CHARS && this.isSearchListDefined();
    }

    submitMainSearchField(element) {
		// Searchvalue added to url // element.prop('disabled', true); 
		var actualpage = window.location.href;	
		var action = element.closest('form').attr('action');
        var keywordValue = btoa(element.val()+"b").replace(/=/g, '');
        window.location.href = action+"#keyword=" + keywordValue;
		// If previous page was already searchpage: force reload
        if (actualpage.indexOf("resultats-recherche")>=0) 
			window.location.reload(true);
		//window.location.assign(action+"#keyword=" + keywordValue);
   }

    trimSpaces(str) { return str.replace(/^\s+|\s+$/g, ""); }

    isSearchListDefined() { return  searchList !== undefined && searchList !== null; }

    hasItem(listEntry, searchEntry) {
        if (searchEntry === '') return;
        let regexp = new RegExp(searchEntry);
        return regexp.test(listEntry);
    }

    highlight(listEntry, searchEntry) {
        return listEntry.replace(
            searchEntry,
            `<strong>${searchEntry}</strong>`
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/header/lhs/transverse/searchPanel.js